import { instance } from "libs/api";

import { ApiRoutesProductUsageGuides } from "../../constants";
import { UsageGuide } from "../../productUsageGuides.types";
import { UpsertUsageGuideRequestBody } from "./upsertUsageGuide.types";

export const requestUpsertUsageGuide = async (
  body: UpsertUsageGuideRequestBody
): Promise<UsageGuide> => {
  // Upsert keyed by scope — the caller does not need to know whether a guide
  // already exists for this product or category.
  return await instance.put(ApiRoutesProductUsageGuides.Guides, body);
};
